// extracted by mini-css-extract-plugin
export default {"root":"x5_wJx5sHw"};